import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import styles from './Sticky.module.scss.js';

var Sticky = (function (_super) {
    __extends(Sticky, _super);
    function Sticky() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isSticky: false,
        };
        _this.shouldComponentUpdate = function (newProps, newState) {
            var propNames = Object.keys(_this.props);
            if (Object.keys(newProps).length !== propNames.length)
                return true;
            var valuesMatch = propNames.every(function (key) {
                return newProps.hasOwnProperty(key) && newProps[key] === _this.props[key];
            });
            if (!valuesMatch)
                return true;
            if (_this.state.isSticky) {
                if (newState.top !== _this.state.top)
                    return true;
                if (newState.left !== _this.state.left)
                    return true;
                if (newState.width !== _this.state.width)
                    return true;
            }
            return newState.isSticky !== _this.state.isSticky;
        };
        _this.onStickyStateChange = function (isSticky) {
            if (_this.props.isActive && !_this.props.forBottom) {
                var height = _this.children ? _this.children.getBoundingClientRect().height : 0;
                if (_this.appContainer) {
                    _this.appContainer.style.paddingTop = isSticky ? height + "px" : 0;
                }
            }
            if (_this.props.onStickyStateChange) {
                _this.props.onStickyStateChange(isSticky);
            }
        };
        _this.getDistanceFromTop = function () {
            if (_this.stickyContainer) {
                return _this.stickyContainer.getBoundingClientRect().top - _this.scrollContainer.getBoundingClientRect().top;
            }
            else {
                return 0;
            }
        };
        _this.getDistanceFromBottom = function () {
            if (_this.stickyContainer) {
                return (_this.stickyContainer.getBoundingClientRect().bottom -
                    _this.scrollContainer.getBoundingClientRect().bottom);
            }
            else {
                return 0;
            }
        };
        _this.isSticky = function () {
            if (_this.props.forBottom) {
                var topBreakpoint = _this.stickyContainer.getBoundingClientRect().top;
                var bodyStyle = window === null || window === void 0 ? void 0 : window.getComputedStyle(document.body, null);
                var offset = parseInt((bodyStyle === null || bodyStyle === void 0 ? void 0 : bodyStyle.paddingBottom) ? bodyStyle.paddingBottom : '0', 10) +
                    parseInt((bodyStyle === null || bodyStyle === void 0 ? void 0 : bodyStyle.paddingBottom) ? bodyStyle.paddingBottom : '0', 10) +
                    _this.children
                    ? _this.children.getBoundingClientRect().height
                    : 0;
                return (_this.getDistanceFromBottom() > 0 &&
                    _this.scrollContainer.scrollTop + _this.scrollContainer.getBoundingClientRect().bottom - offset >
                        topBreakpoint);
            }
            else {
                var bottomBreakpoint = _this.scrollContainer.getBoundingClientRect().top;
                return (_this.getDistanceFromTop() < 0 && _this.stickyContainer.getBoundingClientRect().bottom > bottomBreakpoint);
            }
        };
        _this.recomputeState = function (isActive) {
            if (isActive === void 0) { isActive = false; }
            var isSticky = (isActive || _this.props.forBottom) && _this.isSticky();
            if (isSticky !== _this.state.isSticky) {
                _this.onStickyStateChange(!!isSticky);
            }
            var width = _this.placeholder ? _this.placeholder.getBoundingClientRect().width : 0;
            var left = _this.placeholder ? _this.placeholder.getBoundingClientRect().left : 0;
            var newState = { isSticky: !!isSticky, width: width, left: left };
            if (!_this.props.forBottom && _this.scrollContainer && _this.children) {
                newState.top =
                    _this.scrollContainer.getBoundingClientRect().top - _this.children.getBoundingClientRect().height;
            }
            _this.setState(newState);
        };
        _this.onSmthChanged = function () {
            _this.recomputeState(_this.props.isActive);
        };
        _this.on = function () {
            if (_this.scrollContainer) {
                _this.scrollContainer.addEventListener('scroll', _this.onSmthChanged);
            }
            window === null || window === void 0 ? void 0 : window.addEventListener('resize', _this.onSmthChanged);
            return _this;
        };
        _this.off = function () {
            if (_this.scrollContainer) {
                _this.scrollContainer.removeEventListener('scroll', _this.onSmthChanged);
            }
            window === null || window === void 0 ? void 0 : window.removeEventListener('resize', _this.onSmthChanged);
            return _this;
        };
        return _this;
    }
    Sticky.prototype.componentDidMount = function () {
        this.appContainer = document.getElementById(this.props.appContainerId);
        this.stickyContainer = document.getElementById(this.props.usedStickyContainerId);
        this.scrollContainer = document.getElementById(this.props.scrollContainerId);
        this.on();
        this.recomputeState();
    };
    Sticky.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var containerChanged = false;
        if (this.props.usedStickyContainerId !== nextProps.usedStickyContainerId) {
            containerChanged = true;
            this.stickyContainer = document.getElementById(nextProps.usedStickyContainerId);
        }
        if (this.props.appContainerId !== nextProps.appContainerId) {
            containerChanged = true;
            this.appContainer = document.getElementById(nextProps.appContainerId);
        }
        if (this.props.scrollContainerId !== nextProps.scrollContainerId) {
            containerChanged = true;
            this.scrollContainer = document.getElementById(nextProps.scrollContainerId);
            this.off().on();
        }
        if (containerChanged || this.props.isActive !== nextProps.isActive) {
            this.recomputeState(nextProps.isActive);
        }
    };
    Sticky.prototype.componentWillUnmount = function () {
        this.off();
        this.onStickyStateChange(false);
    };
    Sticky.prototype.render = function () {
        var _a, _b;
        var _this = this;
        var _c;
        var style = {};
        var placeholderStyle = {};
        if (this.state.isSticky) {
            style = {
                left: this.state.left,
                width: this.state.width,
            };
            if (this.props.forBottom) {
                placeholderStyle = {
                    height: this.children.getBoundingClientRect().height,
                };
            }
            else {
                style.top = this.state.top;
            }
        }
        var classNameSticky = classNames(styles.sticky, (_a = {},
            _a[styles.isSticky] = this.state.isSticky,
            _a[styles.forBottom] = this.props.forBottom,
            _a[styles.isActive] = this.props.forBottom && this.props.isActive,
            _a));
        var classNameDecor = classNames(styles.decor, (_b = {},
            _b[styles.isActive] = this.state.isSticky && this.props.forBottom,
            _b));
        return (React.createElement("div", { className: ((_c = this.props) === null || _c === void 0 ? void 0 : _c.className) || '' },
            React.createElement("div", { ref: function (placeholder) { return (_this.placeholder = placeholder); }, style: placeholderStyle }),
            React.createElement("div", { className: classNameSticky, ref: function (children) { return (_this.children = children); }, style: style },
                React.createElement("div", { className: classNameDecor }),
                this.props.children)));
    };
    return Sticky;
}(React.Component));

export { Sticky as default };
//# sourceMappingURL=Sticky.js.map
